import { render } from "./ClaimStep3.vue?vue&type=template&id=40e07afd&ts=true"
import script from "./ClaimStep3.vue?vue&type=script&lang=ts"
export * from "./ClaimStep3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__